import type { LogoProps } from '../../logo.types'
import { logos, symbols } from './logos'

type LogoPulsoProps = LogoProps & {
  onlySymbol?: boolean
}

export const LogoPulso = (props: LogoPulsoProps) => {
  const { size, type, onlySymbol = false } = props

  const SvgComponent = logos[type][size]
  const SymbolsComponent = symbols[type][size]

  return onlySymbol ? SymbolsComponent : SvgComponent
}
